import React from "react";
import { Flex, Typography } from "antd";
import { useTheme } from "styled-components";
import { SbTag, SbDivider } from "uiCore";

import OptionAddInput from "./OptionAddInput";
import { FnDotStyled, TagsWrapStyled } from "./LegalEntityManagement.styles";

const { Text } = Typography;

const FunctionRow = ({ fn, onAddSubFunction, isFirst, subFnOptions = [] }) => {
  const theme = useTheme();
  const existingSubNames = (fn.sub_functions || []).map((s) => s.sub_function);

  return (
    <>
      {!isFirst && <SbDivider dashed />}
      <Flex vertical gap={8}>
        <Flex align="center" gap={6}>
          <FnDotStyled />
          <Text strong>{fn.function}</Text>
        </Flex>

        {(fn.sub_functions || []).length > 0 && (
          <TagsWrapStyled>
            {(fn.sub_functions || []).map((sf, sfIdx) => (
              <SbTag
               style={{ borderRadius: 30 }}
                key={`${sf.sub_function}-${sfIdx}`}
                color={theme?.colors?.primary}
                bordered={false}
              >
                {sf.sub_function}
              </SbTag>
            ))}
          </TagsWrapStyled>
        )}

        <OptionAddInput
          placeholder="Add sub-function"
          existingValues={existingSubNames}
          options={subFnOptions}
          onAdd={onAddSubFunction}
        />
      </Flex>
    </>
  );
};

export default FunctionRow;
